import CrudRepository from './CrudRepository'
import Repository from './Repository'
export default class InternationalCallsRepository extends CrudRepository {
  constructor () {
    super('customerCare/api/internationalCost/country')
  }

  async getExtra (code, lineType) {
    if (code === 'IL') {
      code = 'PS'
    }
    const data = await Repository.get(`${this.resource}/${code}?lineType=${lineType}`)
    return data.data
  }
}
